function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3693 -1338) translate(3060 164) translate(205 144) translate(0 970) translate(16 16) translate(0 32) translate(400) translate(12 12)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "#C06",
  rx: 20
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EE5FA7",
  d: "M30.393 30.152l-4.886-4.658c-.306-.292-.802-.292-1.109 0-.306.292-.306.765 0 1.057l1.51 1.44h-11.67l1.51-1.44c.306-.292.306-.765 0-1.057-.306-.292-.802-.292-1.109 0l-4.886 4.658c-.306.292-.306.766 0 1.058.153.146.354.218.555.218.2 0 .401-.072.554-.218l1.809-1.725h14.805l1.808 1.725c.154.146.354.219.555.219.2 0 .401-.073.554-.22.306-.291.306-.765 0-1.057z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(10.403 7.619)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 3.383C0 1.982 1.016.788 2.404.604 4.442.334 7.378.004 9.597 0c2.265-.003 5.267.332 7.337.605 1.39.184 2.407 1.378 2.407 2.78v12.293c0 1.578-1.28 2.857-2.857 2.857H2.857C1.28 18.535 0 17.255 0 15.678V3.383z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F3A7CD",
  d: "M0 12.381h19.34v3.297c0 1.578-1.279 2.857-2.856 2.857H2.857C1.28 18.535 0 17.255 0 15.678V12.38z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 5.275,
  height: 1,
  x: 7.033,
  y: 2.711,
  fill: "#C06",
  rx: 0.462
}), /*#__PURE__*/React.createElement("rect", {
  width: 6.154,
  height: 5.275,
  x: 2.637,
  y: 5.348,
  fill: "#F5CCE0",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 6.154,
  height: 5.275,
  x: 10.549,
  y: 5.348,
  fill: "#F5CCE0",
  rx: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6.593,
  cy: 15.458,
  r: 1.319,
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12.747,
  cy: 15.458,
  r: 1.319,
  fill: "#FFF"
})))))))))));

var SvgIconServTrain = function SvgIconServTrain(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconServTrain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-serv-train.da5a455d.svg";
export { ForwardRef as ReactComponent };